import { twMerge } from 'tailwind-merge';

type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={twMerge(
        'h-full w-full animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-700',
        className
      )}
    />
  );
}
